<script setup lang="ts">
import usePartnerPlaylistList from './usePartnerPlaylistList'

const { isMobile } = useDevice()
const { playlists, fetchPartnerPlaylists } = usePartnerPlaylistList()
const { addCdnToUrl } = useFormatUrlCdn()

fetchPartnerPlaylists()
</script>

<template>
  <div class="studi-saya-wrapper">
    <a-row :gutter="32">
      <a-col v-if="!isMobile" :span="6">
        <LazyAtomsSidebarAccount />
      </a-col>
      <a-col :sm="24" :md="18">
        <div class="mb-6 text-[24px] leading-9 font-bold">Playlists</div>
        <a-row :gutter="[16, 24]">
          <template v-if="playlists.isLoading">
            <a-col v-for="i in 6" :key="i" :sm="24" :md="12" :lg="8">
              <LazyAtomsCardCourseLoading />
            </a-col>
          </template>

          <a-col
            v-else-if="!playlists.isLoading && isEmpty(playlists.data)"
            :span="24"
          >
            <div class="mt-6">
              <AtomsEmpty height="auto" description="Data tidak ditemukan" />
            </div>
          </a-col>

          <template v-else>
            <a-col
              v-for="playlist in playlists.data"
              :key="playlist.groupSerial"
              :sm="24"
              :md="12"
              :lg="8"
            >
              <NuxtLink
                :to="`/partnerplaylist/${playlist.groupUrlSlug}`"
                :replace="true"
              >
                <div class="kg-card-playlist">
                  <div class="image">
                    <nuxt-img
                      :src="addCdnToUrl(playlist.companyLogoImageUrl)"
                      loading="lazy"
                      size="sm:100%"
                      format="webp"
                      :quality="isMobile ? '50' : '80'"
                      preload
                    />
                  </div>
                  <div class="title">{{ playlist.groupTitle }}</div>
                  <div class="kg-card-playlist__progress">
                    <AtomsProgress
                      :from="playlist.totalCourseCompleted"
                      :to="playlist.totalCourse"
                    />
                  </div>
                </div>
              </NuxtLink>
            </a-col>
          </template>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>

<style lang="scss" scoped>
@import './styles.scss';
</style>
